import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AtSign, GroupSport, Trainer } from '~/Components/Icons';
import { PhoneSimple } from '~/Components/Icons/PhoneSimple';
import { ImageUpload } from '~/Components/ImageUpload';
import { AccessList, useHasAccess } from '~/Hooks';
import { useItemCreationContext } from '~/ModularComponents';
import {
  InputSwitcher,
  InputText,
  ItemCreationInputsContainer,
  ItemCreationInputTemplate,
} from '~/ModularComponents/ItemCreationInputs';
import { useImage } from '~/requests/providerService/useImage';
import { ProfilePictureCard } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles((theme) => ({
  imageColumn: {
    flex: 1,
    display: 'flex',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {},
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  uploadButton: {
    marginLeft: theme.spacing(2),
  },
}));

export const OrganisationSettingsGeneralSection = () => {
  const { t } = useTranslation();
  const { values: organisation, setFieldValue } = useItemCreationContext();
  const { classes } = useStyles();
  const { requestUploadImage, uploadedImage } = useImage();
  const { hasAccess } = useHasAccess();

  useEffect(() => {
    if (!uploadedImage) {
      return;
    }
    setFieldValue('logoUrl', uploadedImage);
    setFieldValue('logoOriginalUrl', uploadedImage);
  }, [uploadedImage]);

  return (
    <ItemCreationInputsContainer title="CREDIT_PASS_DETAILS_SECTION_2">
      <div className={classes.imageColumn}>
        <ProfilePictureCard
          hideLabel
          displayName={organisation.name}
          imageUrl={organisation.logoUrl}
          imageContainerClass={classes.imageContainer}
          textCenter
          fontSize={24}
          imageSize={130}
          actionButton={
            <ImageUpload
              className={classes.uploadButton}
              buttonPrimaryLabel={organisation.logoUrl ? t('app.updateLogo') : t('app.uploadLogo')}
              buttonSecondaryLabel={t('app.updateLogo')}
              onUpload={requestUploadImage}
              canvasStyle={{
                width: 300,
                height: 300,
                color: [0, 0, 0, 0.4],
                borderRadius: 500,
                border: 0,
              }}
            />
          }
        />
      </div>
      <ItemCreationInputTemplate
        name="name"
        InputElement={
          <InputText
            name="name"
            label={`${t('organisation.name')}*`}
            placeholder={t('organisation.name')}
            icon={<GroupSport />}
            maxLength={50}
          />
        }
      />
      <ItemCreationInputTemplate
        name="email"
        InputElement={
          <InputText
            name="email"
            label={`${t('app.email')}*`}
            placeholder={t('app.email')}
            icon={<AtSign />}
          />
        }
      />
      <ItemCreationInputTemplate
        name="phone"
        InputElement={
          <InputText
            name="phone"
            label={t('form.field.placeholder.phone')}
            icon={<PhoneSimple />}
          />
        }
      />
      {hasAccess(AccessList.ORGANISATION_STAFF_NAME_TOGGLE) ? (
        <ItemCreationInputTemplate
          name="isStaffNameVisible"
          icon={<Trainer />}
          label={t('form.field.staffNameVisibility')}
          InputElement={<InputSwitcher name="isStaffNameVisible" />}
        />
      ) : null}
    </ItemCreationInputsContainer>
  );
};
